import Rows from '@svs/ui/react/icons/Rows';
import type { ReactNode } from 'react';

type NumberOfRowsProps = {
  numberOfRows: number;
};

/**
 * The betslip label component wrapper.
 *
 * @param root0 input object
 * @param root0.numberOfRows the number of rows to display inside.
 * @returns div with number of rows inside.
 */
export default function BetslipNumberOfRows({ numberOfRows }: NumberOfRowsProps): ReactNode {
  return (
    <div className="[grid-area:nrOfRows]" aria-label={`${numberOfRows} rader`} aria-live="polite">
      <div
        aria-hidden
        className="grid auto-cols-max grid-flow-col items-center gap-x-[6px] text-nowrap lg:gap-x-[12px]"
      >
        <span>Rader</span>
        <Rows className="mr-[6px] h-[16px] w-[16px] lg:mr-[12px] lg:h-[20px] lg:w-[20px]" />
        <span className="font-bold">{`${numberOfRows} st`}</span>
      </div>
    </div>
  );
}
